/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Damper_RecirculationInputs */



/**
* | output |
* | --- |
* | "Recirculation damper" |
*
* @param {Air_Handler_Unit_Damper_RecirculationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_damper_recirculation = /** @type {((inputs?: Air_Handler_Unit_Damper_RecirculationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Damper_RecirculationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Recirculation damper")
	return /** @type {LocalizedString} */ ("Volet de recirculation")
});